export default {
  namespaced: true,
  state: {
    clusters: [],
    allClusters: [],
    businessNames: [],
    clusterTree: [],
    tenants: [],
    myTenants: [],
    roles: JSON.parse(localStorage.getItem('roles') || '[]'),
    businessGroups: []
  },
  mutations: {
    SET_CLUSTERS(state, value) {
      state.clusters = value
    },
    SET_ALL_CLUSTERS(state, value) {
      state.allClusters = value
    },
    SET_CLUSTER_TREE(state, value) {
      state.clusterTree = value
    },
    SET_BUSINESS_NAMES(state, value) {
      state.businessNames = value
    },
    SET_TENANTS(state, value) {
      state.tenants = value
    },
    SET_MY_TENANTS(state, value) {
      state.myTenants = value
    },
    SET_ROLES(state, value) {
      if (typeof value === 'string') {
        localStorage.setItem('roles', value)
        state.roles = JSON.parse(value)
      } else {
        localStorage.setItem('roles', JSON.stringify(value))
        state.roles = value
      }
    },
    SET_BUSINESS_GROUPS(state, value) {
      state.businessGroups = value
    }
  },
  actions: {
    setClusters({ commit }, clusters) {
      commit('SET_CLUSTERS', clusters)
    },
    setAllClusters({ commit }, clusters) {
      commit('SET_ALL_CLUSTERS', clusters)
    },
    setBusinessNames({ commit }, names) {
      commit('SET_BUSINESS_NAMES', names)
    },
    setClusterTree({ commit }, value) {
      commit('SET_CLUSTER_TREE', value)
    },
    setTenants({ commit }, value) {
      commit('SET_TENANTS', value)
    },
    setMyTenants({ commit }, value) {
      commit('SET_MY_TENANTS', value)
    },
    setRoles({ commit }, value) {
      commit('SET_ROLES', value)
    },
    setBusinessGroups({ commit }, value) {
      commit('SET_BUSINESS_GROUPS', value)
    }
  }
}
